import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import {
  getPostData,
  getProjectsData,
  getOrganization,
  seacrhPosts,
} from "../../services/service.js";
import "../../assets/css/doctor.scss";
import "../../assets/css/pharmacy.scss";

import ListHeader from "../../molecules/ListHeader/ListHeader.js";
import DG from "../../atoms/DataTable/DataGrid.js";
import CustomPagination from "../../atoms/CustomPagination/index.jsx";

const ViewProjects = () => {
  const location = useLocation();
  const [loader, setLoader] = useState(true);
  const [totalProject, setTotalProject] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [projectData, setProjectData] = useState("");
  const [projectId, setProjectId] = useState("");
  const [searchValue, setSearchValue] = useState(""); // Store the current search input value
  const [statusFilter, setStatusFilter] = useState("");
  const [organizationName, setOrganizationName] = useState("");

  const itemsPerPage = 10;

  const handleSearchChange = (filterData) => {
    // filterData comes as an object from FilterForm: { project_id, worker_id, etc. }
    const { project_id } = filterData || {};
    setProjectId(project_id || "");
    setCurrentPage(1);
    // Fetch immediately after applying/clearing filter
    handlegetData(project_id || "", 1, itemsPerPage, searchValue || "");
  };

  // Align parameter order with service: (project_id, page, limit, query)
  const handlegetData = async (project_id, page, limit, query = "") => {
    setLoader(true);
    console.log(project_id, page, limit, query);
    try {
      const response = await getProjectsData(project_id, page, limit, query || "");
      if (response?.success) {
        let data = response?.data || [];
        if (statusFilter === "active") {
          data = data.filter((proj) => proj?.status === true);
        }
        // Fallback: projects API may not include organization, use org fetched from /organization.
        const normalizedData = data.map((proj) => ({
          ...proj,
          organization_name:
            proj?.organization_name ||
            proj?.organization?.title ||
            proj?.organization?.name ||
            proj?.Organization?.title ||
            proj?.Organization?.name ||
            organizationName ||
            "N/A",
        }));
        setProjectData(normalizedData);
        setTotalProject(response?.pagination?.totalItems);
      }
    } catch (error) {
      console.error("Error fetching projects data:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    const fetchOrganizationName = async () => {
      try {
        const response = await getOrganization();
        if (response?.success) {
          const org = response?.data?.organization;
          setOrganizationName(org?.title || org?.name || "");
        }
      } catch (error) {
        console.error("Error fetching organization name:", error);
      }
    };
    fetchOrganizationName();
  }, []);

  useEffect(() => {
    // Read status filter from query params
    const params = new URLSearchParams(location.search);
    const status = params.get("status");
    if (status) {
      setStatusFilter(status);
    }

    setLoader(true);
    const debounceTimer = setTimeout(() => {
      handlegetData(
        projectId || "",
        currentPage,
        itemsPerPage,
        searchValue || ""
      );
    }, 500);

    return () => clearTimeout(debounceTimer);
  // Include projectId so list updates immediately on filter remove/apply
  }, [itemsPerPage, currentPage, searchValue, location.search, statusFilter, projectId, organizationName]);

  // const handleSearchChange = (id) => {
  //   setProjectId(id);
  //   setCurrentPage(1);
  // };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleProjectSearchChange = (value) => {
    // setSearchQuery(value);
    setSearchValue(value);
  };

  return (
    <>
      <div className="row px-[5px]">
        <div className="col-12  ">
          <div className="row d-flex align-items-end">
            <div className="col-12">
              <ListHeader
                mainHeading="Project"
                placeholder="Search"
                btnShow={true}
                linkBreadCrum="/view-project"
                blinkBreadCrumText="Project"
                blinkBreadCrumText1="View Project"
                handleSearchChange={handleSearchChange}
                searchShow={true}
                showLikeFilter={false}
                DropDown={false}
                showWorkerFilter={true}
                handleProjectSearchChange={handleProjectSearchChange}
                searchValue={searchValue}
                showProjectFilter={true}
                moduleType="projects"
              />
            </div>
          </div>
        </div>
        <div className="w-full px-2 pt-3">
          <DG index={3} loader={loader} data={projectData} getData={handlegetData} />
        </div>
        <CustomPagination
          totalItems={totalProject}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />
      </div>
    </>
  );
};

export default ViewProjects;
